import cn from 'classnames/bind';
import PropTypes from 'prop-types';

import s from './StepCard.module.scss';

const cx = cn.bind(s);

const StepCard = ({
  color, index, title, text, className, ...attrs
}) => (
  <div className={cx('step', className)} {...attrs}>
    <div className={cx('stepCount', color)}>{index}</div>
    <div className={cx('stepInfo')}>
      <h4 className={cx('stepTitle', 'tp-header-4')}>{title}</h4>
      <p className={cx('tp-text-small')}>{text}</p>
    </div>
  </div>
);

StepCard.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default StepCard;
